import React, { useEffect } from 'react';
import { NavHeader } from '../PageElements/NavHeader';
import Header from '../PageElements/Header';
import Footer from '../PageElements/Footer';
import '../CSS/MissionStatement.css';
import ScrollReset from '../Tools/ScrollReseter';
import '../CSS/ProvenAndEvolving.css';
import HorizontalLine from '../PageElements/HorizontalLine';
import { Link } from 'react-router';

export default function ProvenAndEvolving() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <ScrollReset />
      <div className='wrapper'>
        <NavHeader maxScroll={200} windowWidth={windowWidth} />
        <Header
          imageURL={'Images/P&E.jpg'}
          title={'Proven & Evolving'}
          titleSize={windowWidth > 750 ? 48 : 24}
          opacity={0.06}
          windowWidth={windowWidth}
        />
        <Content />
        <Footer imageURL={'Images/P&E.jpg'} windowWidth={windowWidth} />
      </div>
    </>
  );
}

function Content() {
  return (
    <>
      <div
        className='content'
        style={{
          width: '100%',
          width: '-moz-available',
          width: '-webkit-fill-available',
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          justifyContent: 'center',
          gap: '50px',
        }}>
        <TopImage />
        <TextBox />

        <HorizontalLine />

        <div className='subSection' id='section1'>
          <div
            style={{
              width: '1000px',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              alignItems: 'start',
              justifyContent: 'center',
              paddingRight: '20px',
              paddingLeft: '20px',
            }}>
            <h1>Proven: Validated Market Performance</h1>

            <p>
              Sókn Engineering has independently validated its technology through rigorous third-party audits and live market testing. The results
              speak for themselves:
            </p>

            <h3>Live Market Validation - December 2024</h3>

            <ul>
              <li>
                <b>182% ROI in 4 Weeks</b> – Outperforming traditional market models.
              </li>
              <li>
                <b>High-Precision Accuracy </b>– Predicted key market inflection points within fractions of a cent.
              </li>
              <li>
                <b>Minimal Slippage</b> – 98% of trades executed at the intended price or within ±1 tick.
              </li>
              <li>
                <b>Verified by Independent Auditors</b> – Real-money live validation conducted with StoneX & third-party firms.
              </li>
            </ul>

            <p>
              Our AI-powered trading models provide a new level of precision and risk control, setting us apart from traditional algorithmic trading
              systems.
            </p>

            <div
              className='AltButton'
              style={{
                cursor: 'pointer',
                fontFamily: 'Jura',
                fontWeight: 'bold',
                color: '#5472B8',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={() => {
                const pdfUrl = '/PDFs/SoknEngineeringValidationReport-122024.pdf';
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.download = 'SoknEngineeringValidationReport-122024.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}>
              Sókn Engineering Validation Report (PDF) <img alt='' src='Icons/Download.svg' height={24} width={24} />
            </div>
          </div>
        </div>

        <HorizontalLine />

        <div className='subSection' id='section2'>
          <div
            style={{
              width: '1000px',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              alignItems: 'start',
              justifyContent: 'center',
              paddingRight: '20px',
              paddingLeft: '20px',
            }}>
            <h1>Evolving: Cutting-Edge Innovation & Expansion</h1>

            <p>
              Our journey doesn’t stop at validation. Sókn Engineering is continuously evolving, refining, and expanding its proprietary technology to
              reshape the trading landscape.
            </p>

            <h3>Upcoming Enhancements</h3>

            <ul>
              <li>
                <b>CME Data Center Co-Location</b> – Moving our trading execution into nanosecond-speed infrastructure for even tighter control over
                slippage and latency.
              </li>
              <li>
                <b>Autonomous AI-Driven Trading</b> – Our models are evolving into a fully self-learning, self-adjusting system, using deterministic
                mathematics to anticipate market moves before they happen.
              </li>
              <li>
                <b>Expansion Beyond Crude Oil</b> – Applying our proprietary Modular Calculus framework to additional commodities, asset classes, and
                financial instruments.
              </li>
              <li>
                <b>Institutional Fund Management</b> – Moving toward an AI-powered proprietary fund, offering data licensing and trading strategies to
                institutional investors.
              </li>
            </ul>

            <p>The Future of Trading is Here – And It’s Constantly Advancing.</p>
          </div>
        </div>

        <HorizontalLine />

        <div className='subSection' id='section3'>
          <div
            style={{
              width: '1000px',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              alignItems: 'start',
              justifyContent: 'center',
              paddingRight: '20px',
              paddingLeft: '20px',
            }}>
            <h1>A Technology That Thinks Ahead</h1>

            <p>
              Unlike traditional quant/stat models, Sókn Engineering’s AI-powered predictive analytics don’t just react to the market—they anticipate
              it.
            </p>

            <ul>
              <li>
                <b>Mathematical Determinism, Not Probability</b> – No reliance on past data trends; we track real-time price intent.
              </li>
              <li>
                <b>550M+ Algorithms, 32T+ Thought Processes</b> – A fully automated, self-learning system.
              </li>
              <li>
                <b>Unparalleled Risk Control</b> – 99% of trades executed within loss mitigation parameters.
              </li>
            </ul>

            <p>
              The market is changing. <b>We’re not following the trend—we’re defining it.</b>
            </p>
          </div>
        </div>

        <HorizontalLine />

        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <div
            style={{
              width: '1000px',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              alignItems: 'start',
              justifyContent: 'center',
              paddingRight: '20px',
              paddingLeft: '20px',
            }}>
            <h1>The Sókn Engineering Impact</h1>

            <p>
              Our mathematics-based technology is already transforming the trading industry, capturing the attention of hedge funds, commodity
              producers, and institutional investors. With live market validation and continuous AI-driven advancements, Sókn Engineering is not just
              a disruptor—we are the future.
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Link
            to={'/contact'}
            draggable={false}
            className='AltButton'
            style={{ fontFamily: 'Jura', fontWeight: 'bold', color: '#5472B8', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            Ask us More <img alt='' src='Icons/RightArrow2.svg' height={14} width={14} />
          </Link>
        </div>
      </div>
    </>
  );
}

function TextBox() {
  return (
    <>
      <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
        <div
          style={{
            width: '950px',
            gap: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            flexDirection: 'column',
            paddingRight: '20px',
            paddingLeft: '20px',
          }}>
          <h1 style={{ fontSize: '24px' }}>Proven & Evolving: The Future of Market Intelligence with Sókn Engineering</h1>

          <p>
            Sókn Engineering stands at the intersection of proven performance and continuous evolution. Our proprietary AI-driven predictive analytics
            models have demonstrated unmatched accuracy, risk control, and ROI in live market validation, and we continue to evolve our technology to
            set new industry standards.
          </p>
        </div>
      </div>
    </>
  );
}

function TopImage() {
  return (
    <>
      <div className='topImage'>
        <svg width='1' height='120' viewBox='0 0 1 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0.5 0.231812V119.768' stroke='url(#paint0_linear_230_561)' />
          <defs>
            <linearGradient id='paint0_linear_230_561' x1='0.5' y1='0.306803' x2='26.0072' y2='5.7883' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#BC9C4E' />
            </linearGradient>
          </defs>
        </svg>

        <img
          className='headerImage'
          alt=''
          height={380}
          width={800}
          src='Images/Singularity.jpg'
          style={{ minWidth: '200px', maxWidth: '800px', height: 'auto', width: '100%' }}
        />

        <svg width='1' height='120' viewBox='0 0 1 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0.5 0.231812V119.768' stroke='url(#paint0_linear_230_561)' />
          <defs>
            <linearGradient id='paint0_linear_230_561' x1='0.5' y1='0.306803' x2='26.0072' y2='5.7883' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#BC9C4E' />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </>
  );
}
